import { Injectable } from '@angular/core';
import { Settings } from '../../../core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReasonsStorage } from '../../../audit-trail/reasons-storage';
import { map, publishLast, refCount } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { AuditTrailReasonReadModel } from '../../../audit-trail/audit-trail-reason';

@Injectable()
export class EQueryHideReasonStorage implements ReasonsStorage {
    private allHideReasons: Observable<string[]>;
    constructor(
        protected readonly settings: Settings,
        protected readonly http: HttpClient
    ) {
    }

    public all(): Observable<string[]> {
        if (!this.allHideReasons) {
            this.allHideReasons = this.loadAllHideReasons()
                .pipe(
                    publishLast(),
                    refCount()
                );
        }

        return this.allHideReasons;
    }

    private loadAllHideReasons(): Observable<string[]> {
        return this.http.get(`${this.settings.apiUrl}/audit-e-query/hide-reasons`)
            .pipe(map(response => deserialize(response, AuditTrailReasonReadModel).reasons));
    }
}
